module.exports = __webpack_public_path__ + "static/lymon-c1fec782a2aac8ec0774aa52650a71cf.png";